<template>
  <div>
    <div class="admin_title">课程管理</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <input type="button" class="btn_s_gj" @click="searchByFilter()" /><input type="text" class="put_gj" name="name" v-model="filter.name" @keyup.13="searchByFilter()"/>
      <select name="isPublic" class="selcet_put" v-model="filter.publicState" @change="searchByFilter()">
        <option value="">全部(公开状态)</option>
        <option v-for='item in Dropdown.state.publicState' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="type" class="selcet_put" v-model="filter.status" @change="searchByFilter()">
        <option value="">全部(课程状态)</option>
        <option v-for='item in Dropdown.state.putOnOffType1' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <!--select v-model="filter.courseClassifiId" @change="searchByFilter">
        <option :value="''">(全部)大分类</option>
        <option v-for='item in courseClassifications' :key="item.id" :value="item.id">{{item.name}}</option>
      </select-->
      <div id="search-treeselect" style="width: 200px; display: inline-block; vertical-align: middle; margin-left: 10px; margin-top: 9px;">
        <treeselect
          :options="options"
          :value="filter.courseClassifiId"
          :searchable="false"
          :show-count="true"
          placeholder="--请选择分类--"
          v-model="filter.courseClassifiId"
          @input="searchByFilter"
        >
        </treeselect>
      </div>
      <!--select v-model="filter.courseClassifiId" @change="searchByFilter">
        <option :value="''">(全部)小分类</option>
        <option v-for='item in courseSmallClassifications' :key="item.id" :value="item.id">{{item.name}}</option>
      </select-->
      <a @click="editCourse('')" class="btn btn_add">新增课程</a>
    </div>
    <div class="class_list">
      <dl v-for="item in list" :key="item.id">
        <dt style="position: relative;">
          <span class="enroll_badge" style="position: absolute; top: -12px; z-index: 12;">{{item.status=='0' ? '已上架' : '已下架'}}</span>
          <img v-if="!item.faceUrl || item.faceUrl===''" src="@/assets/images/class_img.jpg" />
          <img v-if="item.faceUrl && item.faceUrl!==''" :src="item.faceUrl"  />
        </dt>
        <dd>
          <h3 :title="item.name">{{item.name}}</h3>
          <p><a class="marginL8" @click="pubCourse(item.id, '2')" v-if="item.status === '0'" style="cursor: pointer;">下架</a> <a @click="pubCourse(item.id, '1')" class="marginL8" v-if="item.status === '1'" style="cursor: pointer;">上架</a><a href="javascript:;" @click="deleteCourse(item.id)" class="marginL8">删除</a><a href="javascript:;" @click="editCourse(item.id)">编辑</a></p>
        </dd>
      </dl>
      <h5 class="none_ts" v-if="courseCnt <= 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{courseCnt}}个课程</dt>
        <dd v-if="courseCnt>0">
          <paginate ref="paginate" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
    <v-dialog/>
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import {init} from '@/assets/js/public'
import Paginate from 'vuejs-paginate'
import s_query from '@/utils/s_query'
import { getCookie } from '@/store/cookies'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: { Paginate, Treeselect },
  data () {
    return {
      Dropdown: Dropdown,
      pageIndex: 1,
      filter: {
        pageNo: 1,
        pageSize: 12,
        courseClassifiId: 'all',
        name: '',
        publicState: '',
        status: '',
        delFlag: '0'
      },
      largeTypeId: '',
      courseClassifications: [],
      courseSmallClassifications: [],
      options: [], // 课程分类树
      list: [],
      pages: 0,
      courseCnt: 0,
      prefix: this.$route.meta.prefix || ''
    }
  },
  created () {
    if (getCookie('query_record') && getCookie('query_record')[this.$route.path]) {
      this.filter = getCookie('query_record')[this.$route.path]
    }
    this.getCourses(this.filter)
    this.getCourseClassification()
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
  },
  computed: {},
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getCourses(this.filter)
    },
    resetPagination () {
      this.filter.pageNo = 1
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = 0 // 重置 active-class为第一页
      }
    },
    getCourseClassification () {
      this.$api.post(this.$global.courseApiPath, '/course/classification/list', {}, r => {
        // this.courseClassifications = r.data
        this.options = this.dealTree(r.data)
      })
    },
    dealTree (arr) {
      var dealArr = [{id: 'all', label: '全部'}]
      if (arr && arr.length>0) {
        for (var i = 0; i< arr.length; i++) {
          var temp = {
            id: arr[i].id,
            label: arr[i].name
          };
          if (arr[i].nodes && arr[i].nodes.length > 0) {
            temp.children = []
            for (var j = 0; j < arr[i].nodes.length; j++) {
              var child = {
                id: arr[i].nodes[j].id,
                label: arr[i].nodes[j].name
              }
              temp.children.push(child)
            }
          }
          dealArr.push(temp)
        }
      }

      return dealArr
    },
    getOneClassificationBy (id) {
      this.filter.courseClassificationId = id
      this.$api.get(this.$global.courseApiPath, '/course/classification/' + id, {}, r => {
        this.courseSmallClassifications = r.data
        this.searchByFilter()
      })
    },
    searchByFilter () {
      this.resetPagination()
      this.getCourses(this.filter)
    },
    getCourses (filter) {
      s_query.save(this.$route.path, filter)
      this.$api.post(this.$global.courseApiPath, '/course/courses', filter, r => {
        if (r.cntData) {
          this.courseCnt = r.cntData
        } else {
          this.courseCnt = 0
        }
        this.pages = Math.ceil(r.cntData / filter.pageSize)
        this.list = r.data
        this.$nextTick(() => { // 数据初始化时分页组件需要手动更新
          if (this.$refs.paginate) {
            this.$refs.paginate.selected = this.filter.pageNo - 1
          }
        })
      })
    },
    editCourse (id) {
      if (id == '') {
        id = 'create'
      }
      this.$router.push({path: this.prefix + '/org/course/'+ id})
    },
    deleteCourse (id) {
      var self = this
      this.$modal.show('dialog', {
        title: '删除',
        text: '您确认删除该课程？',
        buttons: [
          {
            title: '确认',
            default: true,
            handler: () => {
              self.$modal.hide('dialog')
              this.$api.getRestful(this.$global.courseApiPath, '/course/action/batch', {action: '3', ids: id}, r => {
                self.resetPagination()
                self.getCourses(self.filter)
              })
            }
          },
          {
            title: '取消',
            handler: () => {
              self.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    pubCourse(id, t) {
      var self = this
      let title = (t == '1') ? '上架' : '下架'
      this.$modal.show('dialog', {
        title: title,
        text: '您确认' + title + '该课程？',
        buttons: [
          {
            title: '确认',
            default: true,
            handler: () => {
              self.$modal.hide('dialog')
              this.$api.getRestful(this.$global.courseApiPath, '/course/action/batch', {action: t, ids: id}, r => {
                self.resetPagination()
                self.getCourses(self.filter)
              })
            }
          },
          {
            title: '取消',
            handler: () => {
              self.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss">
  .enroll_badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/course/list.vue